import React, {Component} from "react";
import Select from 'react-select';
import { strings } from "../localization";

export default class Expander extends Component{
    constructor(props){
        super(props);

        this.state = {
            expanded: this.props.isOpen !== undefined ? this.props.isOpen : false,
        };
    }    

    mouseLeaveTimeout = undefined;
    expanderRef = React.createRef();
    
    componentDidMount() {
        document.addEventListener("mouseup", this.onClickOutsideContainer);
    }

    componentWillUnmount() {
        document.removeEventListener("mouseup", this.onClickOutsideContainer);

        if(this.state.expanded){
            if(this.props.onOpen) this.props.onOpen();
        }
        else{
            if(this.props.onClose) this.props.onClose();
        }

    }

    onClickOutsideContainer = (event) => {
        if (this.expanderRef && !this.expanderRef.current.contains(event.target)) {
            if(this.state.expanded){
                clearTimeout(this.mouseLeaveTimeout);
                this.setState({expanded: false});
                if(this.props.onClose) this.props.onClose();
            }
        }
    }

    toggleExpanded = () => {
        if(this.props.disabled) return;
        
        this.setState({expanded: !this.state.expanded});

        if(this.state.expanded){
            if(this.props.onClose) this.props.onClose();
        }
        else{
            if(this.props.onOpen) this.props.onOpen();
        }
    }

    // use this for close button instead of toggleExpanded to ensure state.expanded is false
    closeExpanded = () => {
        clearTimeout(this.mouseLeaveTimeout);
        this.setState({ expanded: false });
        if (this.props.onClose) this.props.onClose();
    }

    renderDropdownHeaderSelect = () => {
        if(this.props.useReactSelectComponent){
            const option = {value: '', label: this.props.label};
            return (
                <Select
                    options={[option]}
                    value={option}
                    clearable={false}
                    searchable={false}
                />
            );
        }

        return (
            <div className={`expander-header-select ${this.props.showPlaceholder ? 'placeholder' : ''}`}>
                <div>
                    {this.props.className === "events-review-filter" ? (strings.reports_filter_tag + ": ") : ""}
                    {this.props.label}
                </div>
                <i className="material-icons">keyboard_arrow_down</i>
            </div>
        );
    }

    handleChange = (e, originalChangeHandler) => {
        if(this.props.closeOnChange){
            clearTimeout(this.mouseLeaveTimeout)
            this.setState({expanded: false}, () => {
                if(originalChangeHandler) originalChangeHandler(e);
            });
        }
        else{
            if(originalChangeHandler) originalChangeHandler(e);
        }
    }

    render() {

        const className = `expander ${this.props.className} ${this.state.expanded ? 'expanded' : ''}`;

        return (
            <div 
                ref={this.expanderRef} 
                className={className}
                name={this.props.name}
                id={this.props.id}
                onMouseLeave={() => {
                    this.mouseLeaveTimeout = setTimeout(() => {
                        this.setState({expanded: false});
                        if(this.props.onClose) this.props.onClose();
                    }, 900);
                }}
                onMouseEnter={() => {
                    clearTimeout(this.mouseLeaveTimeout);
                }}
            >

                {/* header */}
                <div className="expander-header">
                    {this.renderDropdownHeaderSelect()}

                    <div onClick={this.toggleExpanded} className="expander-header-overlay">&nbsp;</div>

                    {this.props.showClearButton &&
                        <div onClick={this.props.onClear} className="expander-clear-button">
                            <i className="material-icons">clear</i>
                        </div>
                    }
                </div>

                {/* body */}
                {!this.props.disabled &&
                    <div className={`expander-body ${this.state.expanded ? 'expanded' : ''}`}>
                        {React.Children.map(this.props.children, (child) =>
                            React.cloneElement(child, {
                                onChange: (e) => this.handleChange(e, child.props.onChange),
                                onClick: (e) => this.handleChange(e, child.props.onClick),
                            })
                        )}
                        
                        {this.props.showCloseButton && (
                            <button className="expander-close-button" onClick={this.closeExpanded}>
                                <i className="material-icons">close</i>
                            </button>
                        )}

                    </div>
                }
            </div>
        );
    }
    
}